module.exports = __webpack_public_path__ + "static/media/uniswapv3.d9065cbf.svg";